const KeyPageWrapper = ({ children }: { children: React.ReactNode }) => (
  <div
    style={{
      display: "grid",
      gap: "20px",
    }}
  >
    {children}
  </div>
);

export { KeyPageWrapper };
